"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgUserBookmark(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M19.063 0c.423 0 .766.343.766.766v22.467a.766.766 0 01-1.265.581l-6.65-5.7-6.65 5.7a.766.766 0 01-1.257-.475L4 23.233V.766C4 .343 4.343 0 4.766 0zm-.766 1.532H5.532v20.034l5.884-5.042a.766.766 0 01.897-.073l.1.073 5.884 5.043V1.532zM11.949 4a2.873 2.873 0 01.848 5.617c1.803.36 3.198 1.845 3.295 3.586l.006.194v.284a.32.32 0 01-.246.31l-.073.009h-7.66a.32.32 0 01-.31-.246l-.009-.073v-.284c0-1.824 1.431-3.406 3.301-3.781A2.87 2.87 0 0111.949 4z",
    fill: "inherit",
    fillRule: "nonzero"
  }));
}

var _default = SvgUserBookmark;
exports.default = _default;